import { AdditionalVariable, NestedThunkEnvelope } from './createProduct.interface';

const unwrapAdditionalVariables = (
  variablesRes: AdditionalVariable[] | NestedThunkEnvelope<AdditionalVariable[]> | undefined | null,
): AdditionalVariable[] => {
  if (Array.isArray(variablesRes)) return variablesRes;
  const inner = variablesRes?.data;
  if (Array.isArray(inner)) return inner;
  return Array.isArray(inner?.data) ? inner.data : [];
};

export default unwrapAdditionalVariables;
